export default __webpack_public_path__ + "static/media/gamefi_02_2.b54064b8.png";